import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import persistService from '../service/persistService'
import csLocale from '../translations/cs-cz.json'
import enLocale from '../translations/en-us.json'
import skLocale from '../translations/sk-sk.json'

export const datePickerDateFormat = 'd.M.yyyy'

const resources = {
    en: { translations: enLocale },
    sk: { translations: skLocale },
    cs: { translations: csLocale },
}

const savedLanguage = persistService.get('language') || 'sk'

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: savedLanguage,
        defaultNS: 'translations',
        fallbackLng: 'sk',
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    })

export default i18n
